module.exports = __webpack_public_path__ + "static/Green-e-Climate-Certified-8bdd7056e5d098197fd579a26fdc95d5.png";